<template>
	<div>
		<v-row>
			<v-dialog v-model="dialog" max-width="800px">
				<!-- <template v-slot:activator="{ on }">
				<v-btn color="primary" dark v-on="on">Open Dialog</v-btn>
				</template> -->
				<template v-slot:activator="{ on }">
					<p v-on="on"><a href="#" class="text-dark-75 text-hover-primary">{{$t('common.cgu')}}</a></p>
				</template>	
				<v-card>
				<v-card-title>
					<span class="headline pl-2">Acceptable Use Policy</span>
				</v-card-title>
					<v-card-text>
						TellMeGenius provides a subscription service that facilitates access to EPM and decision making softwares thanks to tutorial videos.<br><br>

						This acceptable use policy completes the terms and conditions previously agreed and defines the overall code of conduct any user has to have using TellMeGenius.<br> 
						It restricts the ways in which the platform may be used and sets guidelines as to how it should be used.<br>
						It is aimed at all users.<br><br> 

						This acceptable policy is composed of the following:<br>
						1/ Definition section<br>
						2/ Policy statement<br>
						3/ Acceptable uses section<br>
						4/ Unacceptable uses section<br><br>

						1/ Definition section<br><br>

						TellMeGenius:  TellMeGenius means the service provided by Bosco Technologies to discover and watch the content hosted on the TellMeGenius platform. It includes :<br>
						The TellMeGenius platform with all its features and functionalities ;<br>
						The videos and any other content hosted on the platform ;<br><br>

						AUP: Acceptable Use of Policy, is the document defining the set of rules to respect when using TellMeGenius.<br><br>

						User: a user is a person having a personal account on TellMeGenius, with an ID and password, and using it for its acceptable purpose of use.<br><br>

						2/ Policy statement<br><br>

						The AUP is dedicated to all TellMeGenius users, using it with any device (laptop, mobile phone, etc.) whether personal or professional.<br><br>

						3/ Acceptable uses section<br><br>

						Any user must subscribe or be part of an organisation which subscribes to TellMeGenius to be allowed to use it. It is forbidden to use it without subscription.<br> 
						Every user can use it as long as his/her subscription is valid. <br><br>

						Every user is allowed to watch all the videos included in his/her subscription plan for his/her own purpose or for his/her own organization purpose only.<br>
						The videos will be watched by the users to help them use their softwares in their daily jobs and to help them improve their softwares skills.<br><br>

						The quality of the display of the TellMeGenius content may vary from device to device, and may be affected by a variety of factors, such as your location, the bandwidth available through and/or speed of your Internet connection.<br><br> 

						Every user may automatically receive updated versions of TellMeGenius since the platform  - including the content library - is regularly updated.<br>
						In addition, tests to improve TellMeGenius are regularly done by Bosco Technologies.<br><br>


						4/ Unacceptable uses section<br><br>

						Every user agrees not to register, archive, reproduce, copy, modify, create derivative works from, export, display, broadcast, offer for sale, share, or use (except as explicitly authorized in this AUP) any of the videos available on TellMeGenius.<br><br>

						Each user also agrees not to:<br> 
						circumvent, remove, alter or degrade any of the content protections in the TellMeGenius service ; <br>
						use any robot or other automated means to access the TellMeGenius service ;<br>
						decompile, reverse engineer or disassemble any functionnality or other softwares or processes accessible through the TellMeGenius service ; <br>
						insert any code or product or manipulate the content or the functionalities of the TellMeGenius service in any way; or use any data mining, data gathering or extraction method ;<br>
						upload or transmit any material designed to interrupt, destroy or limit the functionality of TellMeGenius, including any software viruses or any other computer code, files or programs.<br>
						</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<!-- <v-btn color="green darken-1" text @click="dialog = false">Disagree</v-btn> -->
					<v-btn color="green darken-1" text @click="dialog = false">Fermer</v-btn>
				</v-card-actions>
				</v-card>
			</v-dialog>
		</v-row>
	</div>
</template>

<script>
	export default {
		name:"cgu",
		data () {
			return {
			dialog: false,
			}
		},
	}
</script>

<style lang="sass" scoped>

</style>